import {
  ApiResultDTO,
  BrandDTO,
  ClaimDTO,
  CompanyTypes,
  ImageDTO,
  InviteConsumerUserDTO,
  RecallDTO,
  SalesOrderDTO,
  UpdateVinRegistrationDTO,
  UserDTO,
  ViewVinRegistrationDTO,
  VinRegistrationDTO,
  VinClient_V1,
  VinDTO,
  VinOwnerRegistrationDTO
} from './generated/api.generated.v1';
import ApiConfig from './ApiConfig';
import { ApiHelper } from 'src/utils';

export default class VehicleService {
  private readonly _vinClient: VinClient_V1;

  constructor() {
    this._vinClient = new VinClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
  }

  private static instance: VehicleService;

  public static GetInstance(): VehicleService {
    if (!VehicleService.instance) {
      VehicleService.instance = new VehicleService();
    }

    return VehicleService.instance;
  }

  GetClaims(vinUid: string): Promise<Array<ClaimDTO>> {
    return this._vinClient.getClaims(vinUid);
  }

  GetImage(vinUid: string): Promise<ImageDTO> {
    return this._vinClient.getImageByUid(vinUid);
  }

  GetRecalls(vinUid: string): Promise<Array<RecallDTO>> {
    return this._vinClient.getRecalls(vinUid);
  }

  GetSalesOrders(vinUid: string): Promise<Array<SalesOrderDTO>> {
    return this._vinClient.getSalesOrders(vinUid);
  }

  GetVin(vinUid: string): Promise<VinDTO> {
    return this._vinClient.getByUid(vinUid);
  }

  GetVinUsers(vinUid: string): Promise<Array<UserDTO>> {
    return this._vinClient.getVinUsers(vinUid);
  }

  GetVinRegistrations(): Promise<Array<ViewVinRegistrationDTO>> {
    return this._vinClient.userVinRegistrations();
  }

  GetVinRegistration(vinRegistrationUid: string): Promise<VinRegistrationDTO> {
    return this._vinClient.userVinRegistration(vinRegistrationUid);
  }

  InviteConsumerUser(vinUid: string, email: string, companyType: CompanyTypes): Promise<InviteConsumerUserDTO> {
    const dto = new InviteConsumerUserDTO();

    dto.email = email;
    dto.vinUid = vinUid;
    dto.companyType = companyType;

    return ApiHelper.ParseDTO<InviteConsumerUserDTO>(() => this._vinClient.inviteConsumerUser(vinUid, dto));
  }

  SendConsumerUserInvitationEmail(vinUid: string, userId: string): Promise<void> {
    return this._vinClient.sendConsumerUserInvitation(vinUid, userId);
  }

  RegisterOwner(dto: VinOwnerRegistrationDTO): Promise<VinOwnerRegistrationDTO> {
    return ApiHelper.ParseDTO<VinOwnerRegistrationDTO>(() => this._vinClient.registerOwner(dto));
  }

  RemoveConsumerUser(vinUid: string, userId: string): Promise<void> {
    return this._vinClient.removeConsumerUser(vinUid, userId);
  }

  UpdateVinRegistration(dto: UpdateVinRegistrationDTO): Promise<UpdateVinRegistrationDTO> {
    return ApiHelper.ParseDTO<ApiResultDTO>(() => this._vinClient.register(dto, <string>dto.vehicleUid));
  }

  DeactiveateRegistration(vehicleUid: string): Promise<ApiResultDTO> {
    return ApiHelper.ParseDTO<ApiResultDTO>(() => this._vinClient.deactivateRegistration(vehicleUid));
  }

  RemoveConsumerVinRegistration(vehicleUid: string, userId: string): Promise<ApiResultDTO> {
    return ApiHelper.ParseDTO<ApiResultDTO>(() => this._vinClient.removeConsumerVinRegistration(vehicleUid, userId));
  }

  UserVehicleBrands(): Promise<Array<BrandDTO>> {
    return this._vinClient.userVehicleBrands();
  }
}
